import TaskEditHistory from './TaskEditHistory';

export default TaskEditHistory;
